export const EVENT_NAME = {
  RACE_CARD_TAB_OPENED: "Race Card Tab Opened"
};
